import { rankingItems } from '@/mocks/homeData';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line',
  down: 'ri-arrow-down-line',
};

const trendColors: Record<string, string> = {
  up: 'text-primary-500',
  down: 'text-secondary-400',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-medium mb-4 whitespace-nowrap">
            <i className="ri-fire-line"></i>
            实时热度
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热搜榜单
          </h2>
          <p className="text-sm text-foreground-500 mt-2">全网最热吃瓜话题实时排名</p>
        </div>

        <div className="space-y-3 max-w-[900px] mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                    {item.title}
                  </span>
                  {item.tag && (
                    <span className="flex-shrink-0 px-1.5 py-0.5 text-[10px] font-bold rounded bg-primary-500 text-background-50 whitespace-nowrap">
                      {item.tag}
                    </span>
                  )}
                </div>
                <span className="text-xs text-foreground-400 mt-1 block">{item.category}</span>
              </div>
              <div className="flex items-center gap-1.5 flex-shrink-0">
                <i className={`text-xs ${trendColors[item.trend]} ${trendIcons[item.trend]}`}></i>
                <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}